/**
 * Which landing page the root shows: the deployment's decision, read once.
 *
 * The server stamps `<meta name="mouja-landing-variant">` into the shell as
 * it serves it (from `PUBLIC_LANDING_VARIANT`; see
 * `apps/server/src/modules/public-site/landing-variant.ts`). Reading the
 * document is synchronous, so the root renders the right page on its first
 * paint with no request and no flash of the other one — and nothing in the
 * application ever asks the hostname, the port, or a Git branch what it is.
 *
 * An absent or unrecognised value means the full landing page: that is the
 * build's own placeholder, and what a development server that never stamps
 * the shell shows. The Vite dev server is such a server; the private-beta
 * page is previewed there through the review route instead.
 */

export type LandingVariant = 'full' | 'coming-soon';

export const LANDING_VARIANT_META_NAME = 'mouja-landing-variant';

export function readLandingVariant(root: Document = document): LandingVariant {
  const content = root
    .querySelector(`meta[name="${LANDING_VARIANT_META_NAME}"]`)
    ?.getAttribute('content');
  return content === 'coming-soon' ? 'coming-soon' : 'full';
}
